import { defineMessages } from 'react-intl';

const _default_1: {
	jiraIssueCreateDescriptionEditorPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	jiraIssueCreateDescriptionEditorPlaceholder: {
		id: 'ai-mate.chat-history.store-assistant.message-actions.issue-create.suggestion-preview.description-placeholder',
		defaultMessage: 'Description',
		description: 'Placeholder for description editor field',
	},
});
export default _default_1;
